import React, { useEffect } from "react";
import { useSelector } from "react-redux";
// import Modal from "react-modal";
// import CommonTable from "../../common-components/common-tables/CommonTable";
// import {
//   CallIcon,
//   CheckCircleIcon,
//   ClockIconV3,
//   ExcludeIcon,
//   EyeIcon,
//   PersonIcon,
//   XCircleIcon,
// } from "../../../images/icons/icons";
// import { formatDateTime } from "../../common-data/Converts";
// import DetailModHeader from "../../common-components/DetailModHeader";
// import BCAReport from "../../trainer-member-engagement/bca-report/BCAReport";
// import TrainerMemberMap from "../../trainer-member-engagement/trainer-member-map/TrainerMemberMap";
// import ThreedayTrialHistory from "../../pt/three-day-trial/ThreedayTrialHistory";
// import TrialAssignForm from "../../pt/three-day-trial/TrialAssignForm";
// import AvailableTrainers from "../live-trials/AvailableTrainers";
import LiveTbCols from "../LiveTbCols";
import PendingBCALogCards from "../mobile-view/PendingBCALogCards";

const PendingBCALogs = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  allDatas,
  setAllDatas,
  userInfoData,
  callFunction,
}) => {
  const {
    bcaPendingNotifications,
    bcaPendingNotificationsError,
    bcaPendingNotificationsLoading,
  } = useSelector((state) => state.live);

  // const iniModValues = {
  //   isModOpen: false,
  //   modName: "",
  //   rowData: "",
  // };
  // const [modValues, setModValues] = useState(iniModValues);

  // const onCloseModal = () => {
  //   setModValues(iniModValues);
  // };

  useEffect(() => {
    if (
      !bcaPendingNotificationsLoading &&
      !bcaPendingNotificationsError &&
      bcaPendingNotifications?.status &&
      bcaPendingNotifications?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: bcaPendingNotifications.data,
        pagination:
          bcaPendingNotifications?.pagination?.length > 0
            ? bcaPendingNotifications.pagination
            : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: [],
        pagination: [],
      }));
    }
  }, [
    bcaPendingNotificationsLoading,
    bcaPendingNotificationsError,
    bcaPendingNotifications,
  ]);

  // const tbColumns = [
  //   {
  //     dataField: "user_name",
  //     text: "member info",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex-col">
  //           <div className="tb-flex">
  //             <span className="tb-data tb-info-icon">
  //               <PersonIcon />
  //             </span>{" "}
  //             <span className="tb-data">{row?.user_name || "NA"}</span>{" "}
  //           </div>

  //           <div className="tb-flex">
  //             <span className="tb-data tb-info-icon">
  //               <CallIcon />
  //             </span>{" "}
  //             <span className="tb-data">{row?.user_mobile || "NA"}</span>{" "}
  //           </div>

  //           {(row?.is_renewal === 1 || row?.is_renewal === 0) && (
  //             <div className="tb-flex">
  //               <span
  //                 className={`tb-badge ${
  //                   row?.is_renewal === 1
  //                     ? "tb-existing"
  //                     : row?.is_renewal === 0
  //                     ? "tb-fresh"
  //                     : ""
  //                 }`}
  //               >
  //                 {row?.is_renewal === 1
  //                   ? "Existing Member"
  //                   : row?.is_renewal === 0
  //                   ? "Fresh"
  //                   : "NA"}
  //               </span>
  //             </div>
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "gym_name",
  //     text: "Gym Name",
  //     formatter: (_, row) => {
  //       return <span className="tb-data">{row?.gym_name || "NA"}</span>;
  //     },
  //   },
  //   {
  //     dataField: "trainer_name",
  //     text: "assigned trainer",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex-col">
  //           <div className="tb-flex">
  //             <span className="tb-data tb-info-icon">
  //               <PersonIcon />
  //             </span>{" "}
  //             <span className="tb-data">{row?.trainer_name || "NA"}</span>{" "}
  //           </div>

  //           <div className="tb-flex">
  //             <span className="tb-data tb-info-icon">
  //               <CallIcon />
  //             </span>{" "}
  //             <span className="tb-data">{row?.trainer_mobile || "NA"}</span>{" "}
  //           </div>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "date_added",
  //     text: "Member Checkin Time",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex">
  //           <span className="tb-data tb-info-icon">
  //             <ClockIconV3 color="#2c3e50" />
  //           </span>{" "}
  //           <span className="tb-data">
  //             {formatDateTime(row?.date_added || "-")}
  //           </span>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "trainer_name",
  //     text: "BCA",
  //     formatter: (_, row) => {
  //       return (
  //         <span
  //           className="tb-data tb-link"
  //           onClick={() =>
  //             setModValues((prevs) => ({
  //               ...prevs,
  //               isModOpen: true,
  //               modName: "BCA_history",
  //               rowData: row,
  //             }))
  //           }
  //         >
  //           view
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "three_day_assigned",
  //     text: "trial",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data tb-icon">
  //           {row?.three_day_assigned ? <CheckCircleIcon /> : <XCircleIcon />}
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "three_day_assigned",
  //     text: "trial",
  //     formatter: (_, row) => {
  //       return (
  //         <span
  //           className="tb-data tb-link"
  //           onClick={() =>
  //             setModValues((prevs) => ({
  //               ...prevs,
  //               isModOpen: true,
  //               modName: "trial_history",
  //               rowData: row,
  //             }))
  //           }
  //         >
  //           {row?.three_day_done_count}/3
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "actions",
  //     text: "Actions",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="pp-employee-payroll-actions">
  //           <button
  //             key="pt-trainer"
  //             type="button"
  //             className="pp-employee-payroll-action-button pp-outlined-border"
  //             onClick={() =>
  //               setModValues((prevs) => ({
  //                 ...prevs,
  //                 isModOpen: true,
  //                 modName: "trial_assign",
  //                 rowData: row,
  //               }))
  //             }
  //           >
  //             <ExcludeIcon />
  //             assign PT trial
  //           </button>

  //           <button
  //             key="map-trainer"
  //             type="button"
  //             className="pp-employee-payroll-action-button pp-outlined-border"
  //             onClick={() =>
  //               setModValues((prevs) => ({
  //                 ...prevs,
  //                 isModOpen: true,
  //                 modName: "trainer_member_map",
  //                 rowData: row,
  //               }))
  //             }
  //           >
  //             <ExcludeIcon />
  //             map trainer
  //           </button>

  //           <button
  //             key="available-trainers"
  //             type="button"
  //             className="pp-employee-payroll-action-button pp-outlined-border"
  //             onClick={() =>
  //               setModValues((prevs) => ({
  //                 ...prevs,
  //                 isModOpen: true,
  //                 modName: "view_details",
  //                 rowData: row,
  //               }))
  //             }
  //           >
  //             <EyeIcon />
  //             view
  //           </button>
  //         </div>
  //       );
  //     },
  //   },
  // ];

  return (
    <>
      <LiveTbCols
        from="bca_pending"
        userInfoData={userInfoData}
        allDatas={allDatas}
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        callFunction={callFunction}
        isLoading={bcaPendingNotificationsLoading}
      />

      {/* <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Edit Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "trainer_member_map" ||
            modValues.modName === "view_details"
              ? "mod-width-50p"
              : modValues.modName === "trial_assign"
              ? "mod-width-50p mod-height-60vh"
              : "mod-width-95vw mod-height-95vh"
          }`}
        >
          {modValues.modName === "view_details" ? null : (
            <DetailModHeader
              info={modValues.rowData}
              onClose={onCloseModal}
              isOnlySubscription={true}
            />
          )}

          {modValues.modName === "BCA_history" ? (
            <BCAReport
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "trainer_member_map" ? (
            <TrainerMemberMap
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              callFunction={callFunction}
            />
          ) : modValues.modName === "trial_history" ? (
            <ThreedayTrialHistory
              rowData={modValues.rowData}
              userInfoData={userInfoData}
            />
          ) : modValues.modName === "trial_assign" ? (
            <TrialAssignForm
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              userInfoData={userInfoData}
              callFunction={callFunction}
            />
          ) : modValues.modName === "view_details" ? (
            <AvailableTrainers
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
            />
          ) : null}
        </div>
      </Modal>

      <div className="common-table-container mt15">
        <CommonTable
          tableData={allDatas.allData}
          tablePagination={allDatas.pagination}
          tableColumns={tbColumns}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isLoading={bcaPendingNotificationsLoading}
        />
      </div> */}

      <div className="only-mobile">
        <PendingBCALogCards
          tableData={allDatas.allData}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={setIsPage}
        />
      </div>
    </>
  );
};

export default PendingBCALogs;
